import $ from "jquery";
import "jquery-mask-plugin";
import "./spinner";
import "./select_service";

// Expose jQuery globally for inline scripts and legacy code
window.$ = $;
window.jQuery = $;


// Contact form helpers
window.ContactSubmitButton = function () {
  return document.querySelector("#new_contact_request input[type=submit]")
}

window.EnableContact = function () {
  const btn = window.ContactSubmitButton()
  if (btn) btn.removeAttribute("disabled")
}

window.DisableContact = function () {
  const btn = window.ContactSubmitButton()
  if (btn) btn.setAttribute("disabled", "disabled")
}
